import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../components/slice/userSlice";
import warReducer from "../components/slice/warSlice";
import accountReducer from "../components/slice/accountSlice";
import costimizeReducer from "../components/slice/costimizeSlice";
import peemsSlice from "./slice/peemsSlice";
import costimizespendRenducer from "./slice/costimizespendSlice";
import devopsSlice from "./slice/devopsSlice";
import a2c_roverSlice from "./slice/a2c_roverSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    war: warReducer,
    account: accountReducer,
    constimize: costimizeReducer,
    peems: peemsSlice,
    costimizespend: costimizespendRenducer,
    devops: devopsSlice,
    devTools: true,
    a2cRover: a2c_roverSlice,
  },
});

export default store;
